<main>
  <!-- ── S1: Hero ── -->
  <section class="contact-section contact-section--alt contact-hero">
    <div class="prose-container contact-hero__inner">
      <h1 class="contact-hero__title">{{ data.hero.title }}</h1>
      <p class="contact-hero__subtitle">{{ data.hero.subtitle }}</p>
      @if (!mascotError()) {
        <div class="contact-hero__mascot">
          <img
            [src]="data.hero.mascotImage"
            [alt]="data.hero.mascotAlt"
            class="contact-hero__mascot-img"
            loading="lazy"
            (error)="onMascotError()"
          />
        </div>
      }
    </div>
  </section>

  <!-- ── S2: Canales de contacto ── -->
  <section class="contact-section">
    <div class="contact-grid" aos="fade-up">
      <header class="contact-section__header">
        <h2 class="contact-section__title contact-section__title--centered">
          {{ data.channels.title }}
        </h2>
        <p class="contact-section__subtitle">{{ data.channels.subtitle }}</p>
      </header>

      <a
        class="contact-channels__hero"
        [href]="data.channels.whatsapp.url"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="data.channels.whatsapp.name"
      >
        <div class="contact-channels__hero-icon">
          <app-icon [icon]="whatsappIcon" [size]="32" />
        </div>
        <div class="contact-channels__hero-body">
          <h3 class="contact-channels__hero-title">{{ data.channels.whatsapp.name }}</h3>
          <p class="contact-channels__hero-desc">{{ data.channels.whatsapp.description }}</p>
          <span class="contact-channels__hero-handle">{{ data.channels.whatsapp.value }}</span>
        </div>
        <span class="contact-channels__hero-cta">{{ data.channels.whatsapp.cta }}</span>
      </a>

      <div class="contact-channels__grid">
        <a
          class="contact-channel contact-channel--email"
          [href]="data.channels.email.url"
          [attr.aria-label]="data.channels.email.title"
        >
          <div class="contact-channel__icon">
            <app-icon [icon]="mailIcon" [size]="24" />
          </div>
          <div class="contact-channel__body">
            <h3 class="contact-channel__title">{{ data.channels.email.title }}</h3>
            <span class="contact-channel__value">{{ data.channels.email.value }}</span>
            <p class="contact-channel__desc">{{ data.channels.email.description }}</p>
          </div>
          <span class="contact-channel__cta">{{ data.channels.email.cta }}</span>
        </a>

        <a
          class="contact-channel contact-channel--phone"
          [href]="data.channels.phone.url"
          [attr.aria-label]="data.channels.phone.title"
        >
          <div class="contact-channel__icon">
            <app-icon [icon]="phoneIcon" [size]="24" />
          </div>
          <div class="contact-channel__body">
            <h3 class="contact-channel__title">{{ data.channels.phone.title }}</h3>
            <span class="contact-channel__value">{{ data.channels.phone.value }}</span>
            <p class="contact-channel__desc">{{ data.channels.phone.description }}</p>
          </div>
          <span class="contact-channel__cta">{{ data.channels.phone.cta }}</span>
        </a>
      </div>
    </div>
  </section>

  <!-- ── S3: Ubicación y horario ── -->
  <section class="contact-section contact-section--alt">
    <div class="contact-grid" aos="fade-up">
      <header class="contact-section__header">
        <h2 class="contact-section__title contact-section__title--centered">
          {{ data.store.title }}
        </h2>
      </header>

      <div class="contact-location__layout">
        <div class="contact-location__content">
          <p class="contact-location__description">{{ data.store.description }}</p>

          <div class="contact-location__info">
            <div class="contact-location__info-item">
              <app-icon [icon]="mapPinIcon" [size]="20" class="contact-location__info-icon" />
              <span>{{ data.store.address }}</span>
            </div>
            <div class="contact-location__info-item">
              <app-icon [icon]="clockIcon" [size]="20" class="contact-location__info-icon" />
              <span>{{ data.store.schedule }}</span>
            </div>
          </div>

          <div class="contact-location__nav-links">
            <a
              [href]="data.store.mapsUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="contact-location__nav-link"
              aria-label="Abrir en Google Maps"
            >
              <img [src]="data.store.mapsLogo" alt="Google Maps" width="32" height="32" />
            </a>
            <a
              [href]="data.store.wazeUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="contact-location__nav-link"
              aria-label="Abrir en Waze"
            >
              <img [src]="data.store.wazeLogo" alt="Waze" width="32" height="32" />
            </a>
          </div>
        </div>

        <iframe
          [src]="mapEmbedUrl"
          class="contact-location__map"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          title="Ubicación de Perrón Store en Google Maps"
        ></iframe>
      </div>
    </div>
  </section>

  <!-- ── S4: Preguntas frecuentes ── -->
  <section class="contact-section">
    <div class="prose-container" aos="fade-up">
      <header class="contact-section__header">
        <h2 class="contact-section__title contact-section__title--centered">
          {{ data.faq.title }}
        </h2>
        <p class="contact-section__subtitle">{{ data.faq.subtitle }}</p>
      </header>

      <div class="contact-faq">
        @for (item of data.faq.items; track item.question) {
          <details class="contact-faq__item">
            <summary class="contact-faq__summary">
              <span class="contact-faq__question">{{ item.question }}</span>
              <span class="contact-faq__chevron" aria-hidden="true">
                <app-icon [icon]="chevronDownIcon" [size]="16" />
              </span>
            </summary>
            <p class="contact-faq__answer">{{ item.answer }}</p>
          </details>
        }
      </div>
    </div>
  </section>

  <!-- ── S5: CTA cierre ── -->
  <section class="contact-section contact-cta" aos="fade-up">
    <div class="contact-grid contact-cta__inner">
      <h2 class="contact-cta__title">{{ data.cta.title }}</h2>
      <p class="contact-cta__subtitle">{{ data.cta.subtitle }}</p>
      <a
        [href]="data.cta.buttonUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="contact-cta__button"
      >
        {{ data.cta.buttonLabel }}
      </a>
    </div>
  </section>
</main>
